import './App.css';
import './fonts.css';
import AppRoutes from './common/navigateUrl';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
  return (
    <div className="App tms-font">
       <AppRoutes/>
    </div>
  );
}

export default App;
